import type { Element } from 'html-react-parser';

export function extractCodeNode(pre: Element): { code: string; language: string } {
  const codeChild = pre.children.find(
    (child): child is Element => child.type === 'tag' && child.name === 'code',
  );
  const node = codeChild ?? pre;
  const classAttr = node.attribs.class || pre.attribs.class || '';
  const match = /language-([\w-]+)/.exec(classAttr) ?? /brush:\s*([\w-]+)/.exec(classAttr);

  const collect = (children: Element['children']): string =>
    children.map((child) => {
      if (child.type === 'text') {
        return child.data;
      }
      if ('children' in child) {
        return collect(child.children);
      }
      return '';
    }).join('');

  return { code: collect(node.children), language: match ? match[1] : 'text' };
}
